import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react';
import { Input, Upload, Radio, Space, Button, Modal } from 'antd';
import { CloudUploadOutlined, FormOutlined, LinkOutlined, MessageOutlined, SendOutlined } from '@ant-design/icons';
import SimpleBarReact from "simplebar-react";

// import { Editor } from '@tinymce/tinymce-react';
import uuid from 'react-uuid';
// import { at } from 'lodash';
import Utils from '../../../misc/Utils';
import Enums from '../../../misc/Enums';
import DocumentViewer from '../../../components/document-viewer/DocumentViewer';
import './Submissions.css';

const { TextArea } = Input;

const Submit = forwardRef((props, ref) => {
   const [submitType, setSubmitType] = useState("1");
   const [uploadFileList, setUploadFileList] = useState([]);
   const [message, setMessage] = useState("");
   const [urlLink, setUrlLink] = useState("");
   const [previewDocument, setPreviewDocument] = useState(null);
   const [previewDocumentName, setPreviewDocumentName] = useState(null);
   const [previewModalVisible, setPreviewModalVisible] = useState(false);

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);

   useEffect(() => {
      return () => {
         if (previewDocument && previewDocument.startsWith('blob:')) {
            URL.revokeObjectURL(previewDocument);
         }
      };
   }, [previewDocument]);

   const upload_props = {
      onRemove: file => {
         if (previewDocumentName === file.name) {
            handleClosePreview();
         }

         setUploadFileList(() => {
            const index = uploadFileList.indexOf(file.originFileObj);
            const newFileList = uploadFileList.slice();
            newFileList.splice(index, 1);
            return newFileList;
         })
      },

      beforeUpload: file => {
         // var list = [];
         // list.push(file);
         // setUploadFileList(list);
         // // console.log(uploadFileList);
         // return false;

         const isPNG = file.type === 'image/png';
         const isJPG = file.type === 'image/jpg' || file.type === 'image/jpeg';
         const isBMP = file.type === 'image/bmp';
         const isDOC = file.type === 'application/msword' || file.type === 'application/vnd.ms-word';
         const isDOCX = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
         const isODT = file.type === 'application/vnd.oasis.opendocument.text';
         const isRTF = file.type === 'application/rtf' || file.type === 'text/rtf';
         const isTXT = file.type === 'text/plain';
         const isMD = file.type === 'text/markdown';
         const isHTML = file.type === 'text/html';
         const isXML = file.type === 'application/xml' || file.type === 'text/xml';
         const isJSON = file.type === 'application/json' || file.type === 'text/json';
         const isCSV = file.type === 'text/csv' || file.type === 'application/csv';
         const isXLS = file.type === 'application/msexcel' || file.type === 'application/vnd.ms-excel';
         const isXLSX = file.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
         const isPPT = file.type === 'application/vnd.ms-powerpoint';
         const isPPTX = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.presentation';
         const isPPSX = file.type === 'application/vnd.openxmlformats-officedocument.presentationml.slideshow';
         const isPDF = file.type === 'application/pdf';
         const isMP4 = file.type === 'video/mp4';
         const isAVI = file.type === 'video/avi';
         const isMP3 = file.type === 'audio/mpeg';
         const isWAV = file.type === 'audio/wav';

         const fileValid = isPDF ||isDOC || isDOCX || isODT || isRTF || isTXT || isMD || isHTML || isXML || isJSON || isCSV || isXLS || isXLSX || isPPT || isPPTX || isPPSX || isMP4 || isAVI || isMP3 || isWAV || isPNG || isJPG || isBMP   ;

         if (fileValid) {
            const allowedFileSize = 100; //--MB
            const isLtMB = file.size / 1024 / 1024 <= allowedFileSize;

            if (isLtMB) {
               var list = uploadFileList;
               list.push(file);
               setUploadFileList(list);
            } else {
               Modal.error({
                  title: 'Homework',
                  content: `Maximum allowed file size is ${allowedFileSize} MB`,
                  centered: true
               });

               return fileValid || Upload.LIST_IGNORE;
            }

            // console.log(uploadFileList);
         } else {
            Modal.error({
               title: 'Homework',
               content: 'You are not allowed to upload that file type',
               centered: true
            });
         }

         return false;
      },

      uploadFileList,
      onPreview: file => {
         handlePreviewAttached(file);
      },
   };

   const handleSubmitTypeChange = (val) => {
      setSubmitType(val);
   }

   const handleSubmitHomework = () => {
      if (message && (uploadFileList.length > 0 || urlLink !== "")) {
         var o2o_mode = Utils.determineOnlineOffline(); //window.location.hostname.match(/localhost|[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}\.[0-9]{2,3}|::1|\.local|^$/gi) ? "offline" : "online";
         var submit_id = "submit_homework_" + o2o_mode + "_" + uuid();
         let submittedData = {
            id: submit_id,
            homework_id: props.homeworkID,
            student_id: user_id,
            message: message,
            document: "",
            file_name: "",
            url_link: urlLink,
         }

         props.onSubmitCallback(submittedData, uploadFileList)
      } else {
         Modal.info({
            title: 'Homework',
            content: (
               <>
                  Please complete the following before submitting:
                  <ul>
                     <li>
                        Message
                     </li>
                     <li>
                        Upload File or External link
                     </li>
                  </ul>
               </>),
            centered: true,
         });
      }
   }

   const handlePreviewAttached = (file) => {
      const sourceFile = file.originFileObj || file;
      const objectUrl = URL.createObjectURL(sourceFile);

      if (previewDocument && previewDocument.startsWith('blob:')) {
         URL.revokeObjectURL(previewDocument);
      }

      setPreviewDocument(objectUrl);
      setPreviewDocumentName(file.name || sourceFile.name);
      setPreviewModalVisible(true);
   }

   const handleClosePreview = () => {
      setPreviewModalVisible(false);
      setPreviewDocument((currentDocument) => {
         if (currentDocument && currentDocument.startsWith('blob:')) {
            URL.revokeObjectURL(currentDocument);
         }

         return null;
      });
      setPreviewDocumentName(null);
   }

   useImperativeHandle(ref, () => ({
      submitHomework: handleSubmitHomework
   }));

   return (
      <>
         <div className="homework-panel-header">
            <div>
               <span className="homework-panel-kicker">Response</span>
               <h3>Submit Homework</h3>
            </div>
            <SendOutlined />
         </div>

         {
            props.returned &&
            <div className="homework-field-block homework-returned-block">
                  <label>Return Remarks</label>
                  <TextArea
                     disabled={true}
                     rows={3}
                     value={props.remarks}
                  />
            </div>
         }

         <div className="homework-field-block">
            <label>
               <MessageOutlined />
               Message
            </label>
               <TextArea
                  disabled={!props.canSubmit}
                  allowClear
                  rows={props.returned ? 3 : 5}
                  onBlur={(event) => setMessage(event.target.value)}
               />
         </div>

         <div className="homework-field-block">
            <label>
               <FormOutlined />
               Submit Method
            </label>
                  <Radio.Group
                     className="homework-submit-method"
                     disabled={!props.canSubmit}
                     name='submittype'
                     defaultValue={"1"}
                     // value={ass_options.enable_timer} 
                     buttonStyle='solid'
                     onChange={(e) => handleSubmitTypeChange(e.target.value)}
                  >
                     <Radio.Button value="0">External Link</Radio.Button>
                     <Radio.Button value="1">Upload File</Radio.Button>
                  </Radio.Group>
         </div>

         <div className="homework-field-block">
                  {submitType === "1"
                     ?
                     <>
                        <label>
                           <CloudUploadOutlined />
                           Upload Homework
                        </label>
                        <div className="homework-upload-scroll">
                           <Upload
                              disabled={!props.canSubmit}
                              style={{ display: "block" }}
                              maxCount={10}
                              multiple
                              {...upload_props}
                              listType="picture"
                              defaultFileList={[...uploadFileList]}
                              className="upload-list-inline"
                              // accept=".pdf,doc,.docx,.odt,.rtf,.txt,.md,.html,.htm,.xml,.json,.csv"
                              accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                                application/vnd.ms-powerpoint,application/vnd.openxmlformats-officedocument.presentationml.presentation,
                                application/vnd.openxmlformats-officedocument.presentationml.slideshow,video/mp4,video/avi,audio/mpeg,audio/wav,
                                .xls,.xlsx,.png,.jpg,.pdf,.ppsx,.ppt,.pptx,"
                           >
                              <Button icon={<CloudUploadOutlined />} block>Select Files (Max: 10)</Button>
                           </Upload>
                        </div>
                     </>
                     :
                     <>
                        <label>
                           <LinkOutlined />
                           External Link
                        </label>
                        <Input
                           allowClear
                           className="homework-link-input"
                           onBlur={(e) => setUrlLink(e.target.value)}
                           disabled={!props.canSubmit}
                        />
                     </>
                  }
         </div>

         {props.showInlineActions !== false &&
            <div className="homework-submit-actions">
                  <Space direction='horizontal' className="homework-submit-action-space">
                     <Button type='primary' icon={<SendOutlined />} onClick={() => { handleSubmitHomework(); }} disabled={!props.canSubmit}>Submit</Button>
                  </Space>
            </div>
         }

         <Modal
            title="Document Preview"
            // className="homework-assignment-modal homework-document-preview-modal"
            centered
            destroyOnClose={true}
            open={previewModalVisible}
            width="80%"
            footer={[
               <Button key="close" shape="round" onClick={() => handleClosePreview()}>
                  Close
               </Button>
            ]}
            onCancel={() => handleClosePreview()}
         >
            <div className='modal-document-viewer homework-document-preview-viewer'>
               <DocumentViewer
                  document={previewDocument}
                  documentname={previewDocumentName}
                  dvheight="calc(100dvh - 220px)"
                  ismodal={true}
               />
            </div>
         </Modal>
      </>
   )
});

export default Submit;
